import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

/**
 * uri 변경 추적 컴포넌트
 * uri가 변경될 때마다 pageview 이벤트 전송
 */
export default function RouteTrackerGA() {
  const location = useLocation()
  const [initialized, setInitialized] = useState(false)

  // localhost는 기록하지 않음
  useEffect(() => {
    if (!window.location.href.includes('localhost')) {
      console.log('GA 초기화 및 추적 시작')
      ReactGA.initialize(import.meta.env.VITE_REACT_GA_TRACKING_ID)
      setInitialized(true)
    }
  }, [])

  // location 변경 감지시 pageview 이벤트 전송
  useEffect(() => {
    if (initialized) {
      console.log('Location 변경 GA 데이터 전송 ', location.pathname)
      ReactGA.set({ page: location.pathname })
      ReactGA.send('pageview')
    }
  }, [initialized, location])

  return null
}
